import { useState, useEffect, useCallback } from 'react';
import { useDroppable } from '@dnd-kit/core';
/* eslint-disable react/prop-types */ // TODO: add props

const DropZone = ({
  annotation,
  renderDropped,
  imageWidth,
  imageHeight,
  draggableAnnotationsInThisDropZone,
}) => {
  const { setNodeRef } = useDroppable({
    id: annotation.id,
  });

  const xPos = `${(imageWidth / 100) * annotation.geometry.x}px`;
  const yPos = `${(imageHeight / 100) * annotation.geometry.y}px`;
  const width = (imageWidth / 100) * annotation.geometry.width;
  const height = (imageHeight / 100) * annotation.geometry.height;

  const [shrinkScale, setShrinkScale] = useState(1);

  const getTotalWidthOfDroppedItems = useCallback(() => {
    if (!draggableAnnotationsInThisDropZone.length) {
      return 0;
    }

    return (
      (imageWidth / 100) *
      draggableAnnotationsInThisDropZone
        .map((a) => a.data.width)
        .reduce((acc, draggableItemWidth) => acc + draggableItemWidth, 0)
    );
  }, [draggableAnnotationsInThisDropZone, imageWidth]);

  useEffect(() => {
    const borderOffsetAdjustment =
      draggableAnnotationsInThisDropZone.length * 5;
    const totalWidth = getTotalWidthOfDroppedItems() + borderOffsetAdjustment;

    const maxHeightOfDraggableItems =
      Math.max(
        ...draggableAnnotationsInThisDropZone.map(
          (a) => (imageHeight / 100) * a.geometry.height
        )
      ) + borderOffsetAdjustment;

    if (totalWidth > width) {
      // Fancy trigonometry way: props to Chris for working this out, leaving it here for fun and profit!
      // const scaleBy = 1 - (Math.abs(totalWidth - width)/Math.sin(45))/(totalWidth/Math.sin(45));
      setShrinkScale(1 - (totalWidth - width) / totalWidth);
    } else if (maxHeightOfDraggableItems > height) {
      setShrinkScale(
        1 - (maxHeightOfDraggableItems - height) / maxHeightOfDraggableItems
      );
    } else {
      setShrinkScale(1);
    }
  }, [
    draggableAnnotationsInThisDropZone,
    imageHeight,
    height,
    width,
    getTotalWidthOfDroppedItems,
  ]);

  const style = {
    position: 'absolute',
    top: yPos,
    left: xPos,
    width: `${width}px`,
    height: `${height}px`,
    display: `flex`,
  };

  const scalingStyle = {
    whiteSpace: `nowrap`,
    transform: `scale(${shrinkScale})`,
    transformOrigin: `top left`,
    margin: `2px 2px`,
    zIndex: 3,
    display: width > height ? `flex` : `block`,
  };

  return (
    <div ref={setNodeRef} style={style}>
      <div style={scalingStyle}>
        {draggableAnnotationsInThisDropZone.map((draggableAnnotation) =>
          renderDropped(draggableAnnotation)
        )}
      </div>
    </div>
  );
};

export default DropZone;
